var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wizard-step-1" },
    [
      _c("document-type-search", {
        attrs: {
          "total-types": _vm.documentTypes.length,
          "filtered-count": _vm.filteredTypes.length
        },
        model: {
          value: _vm.searchQuery,
          callback: function($$v) {
            _vm.searchQuery = $$v
          },
          expression: "searchQuery"
        }
      }),
      _vm.filteredTypes.length > 0
        ? _c(
            "div",
            { staticClass: "document-types-grid" },
            _vm._l(_vm.filteredTypes, function(type) {
              return _c("document-type-card", {
                key: type.value,
                attrs: {
                  type: type,
                  selected: _vm.selectedType === type.value
                },
                on: {
                  click: function($event) {
                    return _vm.$emit("select", type.value)
                  }
                }
              })
            }),
            1
          )
        : _c(
            "div",
            { staticClass: "no-results" },
            [
              _c("feather-icon", {
                staticClass: "mb-3",
                attrs: { icon: "SearchIcon", size: "48" }
              }),
              _c("p", { staticClass: "mb-0" }, [
                _vm._v(
                  'No se encontraron tipos de documentos que coincidan con "' +
                    _vm._s(_vm.searchQuery) +
                    '"'
                )
              ])
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }